document.addEventListener('DOMContentLoaded', function() {
  // Größen-Picker Dropdown Handler
  const sizeButtons = document.querySelectorAll('.upsell-size-trigger');
  
  sizeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const dropdown = this.parentElement;
      const menu = dropdown.querySelector('.upsell-size-dropdown__menu');
      
      // Toggle Dropdown
      menu.classList.toggle('active');
    });
  });

  // Größen-Items
  const sizeItems = document.querySelectorAll('.upsell-size-dropdown__item');
  sizeItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = this.dataset.variantId;
      const menu = this.parentElement;
      
      // Zum Warenkorb hinzufügen
      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            }
          ]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Dropdown schließen
        menu.classList.remove('active');
        
        // Bestätigung anzeigen (optional)
        showCartNotification();
        
        // Optional: Warenkorb aktualisieren
        // document.body.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
        alert('Fehler beim Hinzufügen zum Warenkorb');
      });
    });
  });

  // Dropdown schließen, wenn außerhalb geklickt wird
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.upsell-size-dropdown')) {
      document.querySelectorAll('.upsell-size-dropdown__menu').forEach(menu => {
        menu.classList.remove('active');
      });
    }
  });
});

// Hilfs-Funktion für Warenkorb-Benachrichtigung
function showCartNotification() {
  // Wenn dein Theme eine Warenkorb-Benachrichtigungskomponente hat
  const notification = document.querySelector('cart-notification');
  if (notification) {
    notification.classList.add('notification--visible');
    setTimeout(() => {
      notification.classList.remove('notification--visible');
    }, 3000);
  }
}
